import { useMutation } from "react-query";
import signedBoardResolution from "../services/signedBoardResolution";

function useSignedBoardResolution() {
  return useMutation(["signed-board-resolution"], signedBoardResolution);
}

export default useSignedBoardResolution;
